<script setup>
import {onMounted, ref} from "vue";
import Vue from "vue";
import {usePiniaStore} from "../../store/pinia_store";
import _ from "lodash";
import VoucherInput from "./VoucherInput.vue";

const props = defineProps({
    eventBus: {
        type: Object,
        required: true,
    },
    dentaidApiInstance: {
        type: Function,
        required: true,
    },
    language: {
        type: String,
        required: true,
    },
    initialVouchers: {
        type: Object,
        required: false,
    },
})

const piniaStore = usePiniaStore();

const open = ref(false);
const anotherVoucherOpen = ref(Object.keys(props.initialVouchers).length > 1);
const hasError = ref(false);
const loading = ref(false);
const voucherOneDisabled = ref(false);
const voucherTwoDisabled = ref(false);
const voucherEventBus = new Vue();
const initialValueVoucherOneInput = ref('');
const initialValueVoucherTwoInput = ref('');
const errorCodes = ['code_not_allowed', 'code_doesnt_exist'];
const errorMessage = window.Drupal.t('Not a valid campaigncode');
const voucherTitle = window.Drupal.t('I have a campaigncode');
const anotherVoucherText = window.Drupal.t('Add another campaigncode');

const handleClickOpen = () => {
    open.value = !open.value;
}

const handleClickAnother = () => {
    anotherVoucherOpen.value = !anotherVoucherOpen.value;
}

const handleVoucherOneAdded = (payload) => {
    loading.value = true

    selectVoucher(payload).then(response => {
        if (!response) {
            return;
        }

        voucherOneDisabled.value = true
    })
}

const handleVoucherTwoAdded = (payload) => {
    loading.value = true

    selectVoucher(payload).then(response => {
        if (!response) {
            return;
        }

        voucherTwoDisabled.value = true
    })
}

async function selectVoucher(payload) {
    return props.dentaidApiInstance.post(`/vouchers?token=${piniaStore.parsedToken}&lang=${props.language}`, {
        code: payload
    }).then(response => {
        hasError.value = false

        props.eventBus.$emit('do-refresh-cart', response.data.data.cart.lines)

        return true;
    }).catch((error) => {
        hasError.value = true

        return false;
    }).finally(() => loading.value = false)
}

const handleVoucherOneRemoved = (payload) => {
    loading.value = true

    handleVoucherRemoved(payload).then(response => {
        if (!response) {
            return;
        }

        voucherOneDisabled.value = false
        initialValueVoucherOneInput.value = ''
        voucherEventBus.$emit('clear-input', 'one')
    })
}

const handleVoucherTwoRemoved = (payload) => {
    loading.value = true

    handleVoucherRemoved(payload).then(response => {
        if (!response) {
            return;
        }

        voucherOneDisabled.value = false
        initialValueVoucherTwoInput.value = ''
        voucherEventBus.$emit('clear-input', 'two')
    })
}

async function handleVoucherRemoved(payload) {
    return props.dentaidApiInstance.post(`/vouchers/delete?token=${piniaStore.parsedToken}&lang=${props.language}`, {
        code: payload
    })
        .then(response => {
            props.eventBus.$emit('do-refresh-cart', response.data.data.cart.lines)

            return true;
        })
        .catch(() => {
            return false;
        })
        .finally(() => loading.value = false)
}

const setInitialVoucherInputs = () => {
    if (_.isEmpty(props.initialVouchers)) {
        return;
    }
console.log(props.initialVouchers)
    initialValueVoucherOneInput.value = props.initialVouchers[0].code;

    if (Object.keys(props.initialVouchers).length > 1) {
        initialValueVoucherTwoInput.value = props.initialVouchers[1].code;
    }
}

setInitialVoucherInputs();
</script>

<template>
    <div class="vue-voucher-code-wrapper row">
        <div class="col-12">
            <button class="toggle-button" :class="{'active': open}" @click="handleClickOpen">
              <span class="toggle-text">{{ voucherTitle }}</span>
            </button>
        </div>

        <div class="col-12" v-show-slide="open">
            <VoucherInput
                @voucher-added="handleVoucherOneAdded"
                @voucher-removed="handleVoucherOneRemoved"
                :is-disabled="voucherOneDisabled"
                :initial-input="initialValueVoucherOneInput"
                voucher-key="one"
                :voucher-event-bus="voucherEventBus"
            ></VoucherInput>

            <button
                @click="handleClickAnother"
                class="toggle-another-button"
                :class="{'active': anotherVoucherOpen}"
            >{{ anotherVoucherText }}
            </button>

            <div v-show-slide="anotherVoucherOpen">
                <VoucherInput
                    @voucher-added="handleVoucherTwoAdded"
                    @voucher-removed="handleVoucherTwoRemoved"
                    :is-disabled="voucherTwoDisabled"
                    :initial-input="initialValueVoucherTwoInput"
                    voucher-key="two"
                    :voucher-event-bus="voucherEventBus"
                ></VoucherInput>
            </div>
        </div>

        <div class="col-12 error" v-if="hasError">
            <p>{{ errorMessage }}</p>
        </div>

        <div class="col-12">
            <hr class="w-100">
        </div>
    </div>
</template>
